module.exports = __webpack_public_path__ + "static/img/new_logo.4d95595.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/new_logo.png
// module id = 454
// module chunks = 0 1 4 5 6 7 8 9 10 11